import React, { useState } from "react";
import {
  Typography,
  Grid,
  Stack,
  TextField,
  Button,
  InputAdornment,
  InputLabel,
  CircularProgress,
  Box,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { ReactComponent as MailIcon } from "../Icons/MailIcon.svg";
import { ReactComponent as PasswordIcon } from "../Icons/PasswordIcon.svg";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { emailRegex } from "../Utils";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { storeData } from "../Redux/Feature/AdminSlice";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import './SignUp.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import PhoneInputController from "../CommonComponents/PhoneInputController";
import { toast, ToastContainer } from 'react-toastify'

export default function SignUp({ setDisplayScreen }) {
  const {
    handleSubmit,
    formState: { errors },
    control,
    watch,
    trigger,
  } = useForm({
    mode: 'onChange',
    shouldUnregister: false
  });
  const dispatch = useDispatch();
  const [showScreen, setShowScreen] = useState(1)
  const [passowordEye, setPassowordEye] = useState(true);
  const [responseError, setResponseError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(null);

  const passwordValue = watch('password');

  const [showPassword, setShowPassword] = useState(false);

const handleTogglePassword = () => {
  setShowPassword(prev => !prev);
};

const [showConfirmPassword, setShowConfirmPassword] = useState(false);

const handleToggleConfirmPassword = () => {
  setShowConfirmPassword(prev => !prev);
};

 

  const onSubmit = async (data) => {
    setLoading(true)
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}sign-up`, {
          data
        })

        if(response.status === 201){
          console.log(response)
          localStorage.setItem("token", response.data?.token);
          localStorage.setItem("userId", response.data?.id);
          dispatch(storeData(response.data));
          navigate('/')
          setLoading(false)
        }
    } catch (error) {
        console.log(error)
        toast.error(
          error?.response?.data?.message || "Something went wrong. Please try again later.",
          {
            duration: 5000,
            position: "top-right",
          }
        );
        setLoading(false)
    }
  };

  const goToStep2 = async () => {
    const isStep1Valid = await trigger(['name', 'dob', 'gender', 'schoolAttended', 'grade', 'yearOfStudy']);
    if (isStep1Valid) setShowScreen(2);
  };

  return (
    <Grid
      xs={12}
      sm={8}
      md={5}
      lg={5}
      p={5}
      sx={{
        border: ".5px solid #D8D8D8",
        borderRadius: "24px",
        height: "auto",
        boxShadow: "0px 5px 11px 0px rgba(0, 0, 0, 0.06)",
      }}
    >
      <ToastContainer />
      <form onSubmit={handleSubmit(onSubmit)}>
    
<>
<Box style={{ display: showScreen === 1 ? 'block' : 'none' }}>
        <Box sx={{display : 'flex', flexDirection : 'column', justifyContent : 'center', alignItems : 'center'}}>
          <Typography mb={0.5} sx={{fontWeight : 700, fontSize : '32px'}}>
            Sign Up{" "}
          </Typography>
          <Typography sx={{fontWeight : 400, fontSize : '20px'}}>Start your journey with us</Typography>
          </Box>
          <Box sx={{mt : '25px'}}>
          <Typography sx={{fontSize : '24px', fontWeight : 500}}>Students Information</Typography>
          </Box>
          
          <Box sx={{mt : '20px'}}>
              <InputLabel
                sx={{
                
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Full name<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                name={`name`}
                rules={{
                    required: "Name is required",
                    maxLength: {
                      value: 70,
                      message: "Name cannot exceed 70 Characters",
                    },
                    minLength : {
                      value: 3,
                      message: "Name cannot below 3 Characters",
                    }
                  }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                    placeholder={`Enter Full name`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.name ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.name ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.name ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.name ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.name) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.name ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>{errors?.name?.message}</Typography> : null }
            </Box>

            <Box sx={{mt : '20px', display : 'flex', justifyContent : 'space-between'}}>
                <Box sx={{width : '48%'}}>
              <InputLabel
                sx={{
                
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Select gender<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                      name="gender"
                      control={control}
                    //   defaultValue={Details?.nationality}
                      rules={{
                        required: true,
                      }}
                      render={({ field }) => (
                        <FormControl
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: errors?.gender ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errors?.gender
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: errors?.gender
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors?.gender
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        >
                          <Select
                            {...field}
                            displayEmpty
                            error={Boolean(errors.gender)}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem value="" disabled>
                              Select gender
                            </MenuItem>
                            <MenuItem value="Male">Male</MenuItem>
                            <MenuItem value="Female">Female</MenuItem>
                            <MenuItem value="other">Other</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    />
              {errors?.gender ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please select gender</Typography> : null }
              </Box>

              <Box sx={{width : '48%'}}>
              <InputLabel
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Date of Birth<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                      name="dob"
                      control={control}
                    //   defaultValue={Details?.dob ? dayjs(Details?.dob) : null}
                      
                      rules={{ required: true }}
                      render={({ field }) => (
                        <LocalizationProvider style={{pt : 0}} dateAdapter={AdapterDayjs}>
                          <DemoContainer style={{pt : 0}} components={["DatePicker"]}>
                            <DatePicker
                                style={{pt : 0}}
                              {...field}
                              sx={{
                                width: "100%",
                                pt : '0px',
                                backgroundColor: "rgb(249, 250, 251)",
                                ".MuiSvgIcon-root": { fill: "#1A2461" },
                                "& .MuiInputBase-input": {
                                  color: errors?.dob ? "red" : "black", // Text color based on error state
                                },
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: errors?.dob
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.23)", // Default border color
                                  },
                                  "&:hover fieldset": {
                                    borderColor: errors?.dob
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.87)", // Hover border color
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: errors?.dob
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.87)", // Focused border color
                                  },
                                },
                              }}
                              format="DD/MM/YYYY"
                              fullWidth
                              maxDate={dayjs()}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      )}
                    />
                    {errors?.dob && (
                      <Typography
                        style={{ color: "#ff5e74", marginTop: "0.3rem" }}
                      >
                        Please select Date of Birth
                      </Typography>
                    )}
              </Box>
            </Box>


            <Box sx={{mt : '20px'}}>
              <InputLabel
                sx={{
                
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                School Attended<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                name={`schoolAttended`}
                rules={{
                    required: "School attended is required",
                    maxLength: {
                      value: 70,
                      message: "School attended cannot exceed 70 Characters",
                    },
                    minLength : {
                      value: 3,
                      message: "School attended cannot below 3 Characters",
                    }
                  }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                    placeholder={`Enter School Attended`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.schoolAttended ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.schoolAttended ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.schoolAttended ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.schoolAttended ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.schoolAttended) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.schoolAttended ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>{errors?.schoolAttended?.message}</Typography> : null }
            </Box>
                    
        <Box sx={{mt : '20px', display : 'flex', justifyContent : 'space-between'}}>
        <Box sx={{width : '48%'}}>
              <InputLabel
                sx={{
                
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Grade<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                name={`grade`}
                rules={{
                    required: "Grade is required",
                    maxLength: {
                      value: 70,
                      message: "Grade cannot exceed 70 Characters",
                    },
                    minLength : {
                      value: 1,
                      message: "Grade cannot below 1 Characters",
                    }
                  }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                    placeholder={`Enter grade`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.grade ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.grade ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.grade ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.grade ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.grade) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.grade ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>{errors?.grade?.message}</Typography> : null }
            </Box>

            <Box sx={{width : '48%'}}>
              <InputLabel
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Year of Study<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                      name="yearOfStudy"
                      control={control}
                    //   defaultValue={Details?.dob ? dayjs(Details?.dob) : null}
                      
                      rules={{ required: true }}
                      render={({ field }) => (
                        <LocalizationProvider style={{pt : 0}} dateAdapter={AdapterDayjs}>
                          <DemoContainer style={{pt : 0}} components={["DatePicker"]}>
                            <DatePicker
                                style={{pt : 0}}
                              {...field}
                              sx={{
                                width: "100%",
                                pt : '0px',
                                backgroundColor: "rgb(249, 250, 251)",
                                ".MuiSvgIcon-root": { fill: "#1A2461" },
                                "& .MuiInputBase-input": {
                                  color: errors?.yearOfStudy ? "red" : "black", // Text color based on error state
                                },
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: errors?.yearOfStudy
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.23)", // Default border color
                                  },
                                  "&:hover fieldset": {
                                    borderColor: errors?.yearOfStudy
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.87)", // Hover border color
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: errors?.yearOfStudy
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.87)", // Focused border color
                                  },
                                },
                              }}
                              format="DD/MM/YYYY"
                              fullWidth
                              maxDate={dayjs()}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      )}
                    />
                    {errors?.yearOfStudy && (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        Please select year of study
                      </Typography>
                    )}
              </Box>
        </Box>


        <Box
         sx={{
            mt: '32px',
            width: "100%",
            backgroundColor: "#1A2461",
            "&:hover": { backgroundColor: "#1A2461", cursor : 'pointer' },
           
            display : 'flex',
            justifyContent : 'center',
            alignItems : 'center',
          
            padding: "10px 20px",
            borderRadius: "8px",
            letterSpacing: ".7px",
            height : '64px'
          }}
          onClick={() => goToStep2()}
        >
          <Typography
           sx={{
            fontWeight: 700,
            color: "#FFFFFF",
            fontSize: "20px",
           }}
           
          >
            {loading ? (
              <CircularProgress size={25} sx={{ color: "#FFFFFF" }} />
            ) : (
              "Next"
            )}
          </Typography>
          </Box>
          </Box>
</>

        
            <>
            <Box style={{ display: showScreen === 2 ? 'block' : 'none' }}>
        <Box sx={{display : 'flex', flexDirection : 'column', justifyContent : 'center', alignItems : 'center'}}>
          <Typography mb={0.5} sx={{fontWeight : 700, fontSize : '32px'}}>
            Sign up{" "}
          </Typography>
          <Typography sx={{fontWeight : 400, fontSize : '20px'}}>Start your journey with us</Typography>
          </Box>
          <Box sx={{mt : '25px', display : 'flex', justifyContent : 'space-between', alignItems : 'center'}}>
          <Typography sx={{fontSize : '24px', fontWeight : 500}}>Contact Information</Typography>
          <ArrowBackIcon sx={{cursor : 'pointer'}} onClick={() => setShowScreen(1)}/>
          </Box>
          
          <Box sx={{mt : '20px'}}>
              <InputLabel
                sx={{
                
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Phone<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <PhoneInputController
                name="phone"
                control={control}
                rules={{ required: 'Phone number is required' }}
              />
              {errors?.phone ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>{errors?.phone?.message}</Typography> : null }
            </Box>

            

        <Box sx={{mt : '20px'}}>
              <InputLabel
                sx={{
                
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Email<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                name={`email`}
                rules={{
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email address",
                    },
                  }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                    placeholder={`Enter email`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.email ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.email ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.email ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.email ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.email) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.email ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>{errors?.email?.message}</Typography> : null }
            </Box>

            <Box sx={{mt : '20px'}}>
              <InputLabel
                sx={{
                
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Create Password<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                name={`password`}
                rules={{
                  required: 'Password is required',
                  minLength: {
                    value: 8,
                    message: 'Password must be at least 8 characters',
                  },
                  maxLength: {
                    value: 16,
                    message: 'Password must not exceed 16 characters',
                  },
                  validate: {
                    hasUppercase: value =>
                      /[A-Z]/.test(value) || 'Must include at least one uppercase letter',
                    hasLowercase: value =>
                      /[a-z]/.test(value) || 'Must include at least one lowercase letter',
                    hasNumber: value =>
                      /[0-9]/.test(value) || 'Must include at least one number',
                    hasSpecialChar: value =>
                      /[!@#$%^&*(),.?":{}|<>]/.test(value) || 'Must include at least one special character',
                  },
                }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                  type={showPassword ? 'text' : 'password'}
                    placeholder={`Enter password`}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleTogglePassword} edge="end">
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.password ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.password ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.password ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.password ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.password) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.password ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>{errors?.password?.message}</Typography> : null }
            </Box>

            <Box sx={{mt : '20px'}}>
              <InputLabel
                sx={{
                
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Confirm Password<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                name={`confirm_password`}
                rules={{
                  required: 'Please confirm your password',
                  validate: value => value === passwordValue || 'Password do not match',
                }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                  type={showConfirmPassword ? 'text' : 'password'}
                    placeholder={`Enter password`}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleToggleConfirmPassword} edge="end">
                            {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.confirm_password ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.confirm_password ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.confirm_password ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.confirm_password ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.confirm_password) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.confirm_password ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>{errors?.confirm_password?.message}</Typography> : null }
            </Box>
            

          <Button
            type="submit"
            // onClick={() => setShowScreen(1)}
            sx={{
              mt: '32px',
              width: "100%",
              backgroundColor: "#1A2461",
              "&:hover": { backgroundColor: "#1A2461" },
              fontSize: "20px",
              fontWeight: 700,
              color: "#FFFFFF",
              padding: "10px 20px",
              borderRadius: "8px",
              letterSpacing: ".7px",
              height : '64px'
            }}
          >
            {loading ? (
              <CircularProgress size={25} sx={{ color: "#FFFFFF" }} />
            ) : (
              "Sign Up"
            )}
          </Button>
          </Box>
</>
           
        

          <Box sx={{mt : '16px', display : 'flex', justifyContent : 'center', gap : 1, alignItems :'center'}}>
              <Typography>Already have an account?</Typography>
              <Typography sx={{color : '#27BAC4', fontWeight : 700, ':hover' : {cursor : 'pointer'}}} onClick={() => setDisplayScreen("login")}>Login</Typography>
          </Box>
        
      </form>
    </Grid>
  );
}